<template>
  <div class="grade" v-loading.fullscreen.lock="fullscreenLoading">
    <Banner ref="banner" :competition="competition"></Banner>

    <div class="content">
      <div class="title">
        <img src="../../assets/saishianpai-title-icon.png" alt="" />
        <p class="tit">分数查看</p>
      </div>
      <div class="intro" v-if="form.intro">
        <p class="intro-p" v-html="form.intro"></p>
      </div>
      <div class="form">
        <el-form ref="form" :model="form" label-width="120px" size="medium">
          <el-form-item v-if="form.name" label="姓名：">
            {{ form.name }}
          </el-form-item>
          <el-form-item v-if="form.certNumber" label="准考证号：">
            {{ form.certNumber }}
          </el-form-item>
          <el-form-item v-if="form.examScore" label="考试成绩：">
            {{ form.examScore }}
          </el-form-item>
          <el-form-item v-if="form.examResult" label="考试结果：">
            <span :style="{ color: examResultColor }">{{ form.examResult }}</span>
          </el-form-item>
          <el-form-item v-if="form.workResult" label="作品成绩：">
            {{ form.workResult }}
          </el-form-item>
          <el-form-item v-if="form.finalResult" label="最终成绩：">
            {{ form.finalResult }}
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/banner";
import { getExaminationResult, getCompetitionDetail } from "@/api";

export default {
  name: "Grade",
  components: { Banner },
  data() {
    return {
      form: {
        name: "",
        certNumber: "",
        examResult: "",
        workResult: "",
        finalResult: "",
        intro: "",
      },
      fullscreenLoading: false,
      competition: {},
    };
  },
  computed: {
    competitionId({ $route }) {
      return $route.query.competitionId;
    },
    examResultColor() {
    if (this.form.examResult?.includes("恭喜您")) {
      return 'green';
    } else if (this.form.examResult?.includes("很遗憾")) {
      return 'orange';
    }else {
      return 'white';
    }
  }
  },
  created() {
    this.getExaminationResult();
    this.getCompetitionDetail();
  },
  mounted() {
    console.dir(this.$refs.banner.$el.querySelector("img").clientHeight);
  },
  methods: {
    getExaminationResult() {
      getExaminationResult(this.competitionId).then(({ data }) => {
        this.form = data;
      });
    },
    //赛事详情接口
    getCompetitionDetail() {
      let params = {
        competitionId: this.$route.query.competitionId,
      };
      this.fullscreenLoading = true;
      getCompetitionDetail(params)
        .then((res) => {
          this.fullscreenLoading = false;
          this.competition = res.data.competition;
          sessionStorage.setItem(
            "competition",
            JSON.stringify(res.data.competition)
          );
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.grade {
  font-size: 20px;
  font-weight: 600;
  color: #07d9c8;
  line-height: 36px;
  background: #171f30;
  overflow: hidden;
}

::v-deep .el-input__inner {
  border-radius: 4px;
  border: 1px solid #e9ecf2;
  background: none;
  color: #fff;
}
::v-deep .el-form-item {
  margin-bottom: 30px;
}
::v-deep .el-form-item__label {
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
}

::v-deep .el-form-item__content {
  color: #ffffff;
}

.form {
  padding: 54px 370px 0 100px;
}
.title {
  display: flex;
  align-items: center;
}
.title img {
  width: 42px;
}
.title .tit {
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  line-height: 40px;
  margin-left: 24px;
}
.content {
  position: relative;
  width: 1178px;
  background: url("../../assets/detail-bg.png");
  margin: 0 auto;
  background: #0a2b51;
  border-radius: 20px;
  border: 1px solid #046bde;
  margin-top: -80px;
  padding: 55px 54px 50px;
  margin-bottom: 150px;
}

.intro {
  display: flex;
  justify-content: center;
  margin: 54px auto 0;
  width: 800px;
}

.intro-p {
  padding: 13px 20px;
  background-color: #e6f2ff;
  border-radius: 4px;
  color: #046bde;
}
</style>
